import { thingMoveEvent } from '@/play/things/things'

/** One drop of a block: its cells moved by a whole-cell offset (one undo step; into a slot when near one). */
export const SPELL_IT_MOVE = thingMoveEvent('experience.spell-it.move')

/** Reducer handlers for Spell it (`experience.spell-it.*`). */
export const eventHandlers = SPELL_IT_MOVE.handlers
